import { JITSI_CONSTANTS } from '../constants/JITSI_CONSTANTS';

/**
 * @group Functions
 *
 * @summary
 * <blockquote>Extracts room name from Prosody tenant-prefixed format.
 * Strips [vpaas-magic-cookie-xxx] prefix if present.</blockquote>
 *
 * @example
 * ```typescript
 * import { parseJitsiRoomName } from '@shared/telehealth/jitsi';
 *
 * parseJitsiRoomName('[vpaas-magic-cookie-abc123]consultation-uuid'); // 'consultation-uuid'
 * parseJitsiRoomName('consultation-uuid'); // 'consultation-uuid'
 * ```
 */
export function parseJitsiRoomName(rawName: string): string {
  return rawName.replace(JITSI_CONSTANTS.TENANT_PREFIX_REGEX, '').trim() || rawName;
}
